"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  return "_" + Math.random().toString(36).substr(2, 9);
};

exports.default = _default;
//# sourceMappingURL=generateId.js.map